import Instance from '../ClientInstance';
import centers, { ICentersOrgOwners, ICentersOrgAdmins, ICentersCenterTeachers } from './centers';
import organizations, { IOrganizationsOwners, IOrganizationsAdmins, IOrganizationsTeachers, IOrganizationsDirectors } from './organizations';

interface IOrgScope extends
  IOrganizationsOwners,
  IOrganizationsAdmins,
  ICentersOrgOwners,
  ICentersOrgAdmins,
  IOrganizationsDirectors,
  IOrganizationsTeachers {}

interface ICenterScope extends
ICentersCenterTeachers {}

interface IApi {
  Instance: any;
  organizationScope: {
    [key: string]: IOrgScope;
  };
  centerScope: {
    [key: string]: ICenterScope;
  };
}

const ClientApi: IApi = {
  Instance,
  organizationScope: {
    ownersNamespace: {
      ...centers.organizations.owners,
      ...organizations.organizations.owners,
    },
    adminsNamespace: {
      ...centers.organizations.admins,
      ...organizations.organizations.admins,
    },
    directorNamespace: {
      ...centers.organizations.teachers,
      ...organizations.organizations.director,
    },
    teachersNamespace: {
      ...centers.organizations.teachers,
      ...organizations.organizations.teachers,
    },
    sharedNamespace: {
      ...centers.organizations.shared,
    },
  },
  centerScope: {
    teachersNamespace: {
      ...centers.centers.teachers,
    },
  },
};

export default ClientApi;
